export const CORNER_COLORED_INDICATOR_TEST_ID = "corner-colored-indicator";
